import { firestore } from "../../firebase/configure";
import { COLLECTIONS } from "../../constants/enums";

export const getUser = (uid: string) => {
    return firestore.collection(COLLECTIONS.USERS).doc(uid);
};
